import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';

import { Btn1 } from './StyledComponents';
import VenomHireButton from './Utils/VenomHireButton.jsx';
import { Link } from 'react-router-dom';
import {Slide, SwipeableDrawer, useScrollTrigger, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import Aos from 'aos';
import 'aos/dist/aos.css';


function HideOnScroll(props) {
  const { children} = props;
  const trigger = useScrollTrigger();

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children ?? <div />}
    </Slide>
  );
}







const pages = [
  {page:"Home",href:"?section=home"},
  {page:"About",href:"?section=aboutMe"},
  {page:"Skills",href:"?section=skill"},
  {page:"Resume",href:"?section=resume"},
  {page:"works",href:"?section=works"},
  {page:"Contact Me",href:"?section=contact"},
  {page:"Hire Me",href:"?section=contact"},

  
];

function NavBar(props) {
  
  const [open, setOpen] = React.useState(false);
  const[mode,setMode] = React.useState("dark");
  const theme = useTheme();
 

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  function handleMode()
  {

    if(mode === "dark")
    {
      setMode("light");
      props.changeMode("light");
    }
    else{
      setMode("dark");
      props.changeMode("dark");
    }
  }
  React.useEffect(() => {
    Aos.init({
      duration: 1000,
      once: true,
    });
  }, []);

  React.useEffect(() => {
    Aos.refresh(); 
  }, [theme.mode]);
  return (
    <>
    {/* <CssBaseline/> */}
      <HideOnScroll {...props} >
        <AppBar position="sticky" sx={{backgroundColor:"transparent",boxShadow:"none",backdropFilter:"blur(10px)"}} >
          <Box>
            <Toolbar disableGutters>
              <Typography
                variant="h6"
                noWrap
                component="a"
                href="#"
                sx={{
                  fontWeight: 700,
                  letterSpacing: '.1rem',
                  color:'text.primary',
                  textDecoration: 'none',
                }}
              >
                Sharief
              </Typography>
              <IconButton 
                onClick={handleMode}
                size="large"
                sx={{
                  '&:hover': {
                    backgroundColor: 'shade.light',
                  },
                }}
              >
                {mode === "dark"?<LightModeIcon sx={{color:'text.primary'}}/>:<DarkModeIcon/>}
              </IconButton>
              <Box sx={{flexGrow:1,display: { xs: 'flex', lg: 'none' },justifyContent:'right'}}>
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={toggleDrawer(true)}
                >
                  <MenuIcon sx={{color:'text.primary'}}/>
                </IconButton>
                <SwipeableDrawer 
                  anchor="top"
                  open={open} 
                  onClose={toggleDrawer(false)}
                  onOpen={toggleDrawer(true)}
                  sx={{
                    '& .MuiPaper-root': {
                      backgroundColor: 'background.default', 
                    },
                  }}
                  
                >
                  <Box 
                    p={3}
                    sx={{
                      display:"flex",
                      flexDirection:"row",
                      justifyContent:"space-between",
                      // flexWrap:"nowrap"
                      

                    }}
                  >
                    <Box
                      sx={{
                        display:"flex",
                        flexDirection:"column",
                        justifyContent:"center",
                        gap:"10px",
                      // backgroundColor:"transparent",
                        

                      }}
                    >
                        {
                          pages.map((obj,index) => {
                              return (
                                <Box key={obj}>
                                    <Btn1
                                        disableRipple
                                        key={obj.page}
                                        component={Link}
                                        to={obj.href}
                                        sx={{ 
                                          color:'text.primary'
                                        }}
                                      onClick={toggleDrawer(false)}
                                    >
                                      {obj.page}
                                    </Btn1>
                                </Box>
                              )
                          })
                        }
                    </Box>
                    <IconButton
                      size="large"
                      aria-label="account of current user"
                      aria-controls="menu-appbar"
                      aria-haspopup="true"
                      onClick={toggleDrawer(false)}
                      sx={{alignSelf:"flex-start"}}
                    >
                      <CloseIcon sx={{color:'text.primary'}}/>
                    </IconButton>
                  </Box>
                </SwipeableDrawer>
              
              </Box>
              
              <Box sx={{ 
                    flexGrow: 1, 
                    display: { xs: 'none', lg: 'flex' },
                    justifyContent:"right",
                    gap:"28px"
                    }}>
                {pages.map((obj,index) => {
                    if(index === pages.length-1)
                    {
                        return (
                            <VenomHireButton
                                key={obj.page}
                                sx={{ my: 2, display: 'block' }}
                                component={Link}
                                to={obj.href}
                                
                            >
                              {obj.page}
                            </VenomHireButton>
                        )
                    }
                    return (
                        <Btn1
                            key={obj.page}
                            sx={{ my: 2, display: 'block' }}
                            component={Link}
                            to={obj.href}
                        >
                            {obj.page}
                        </Btn1>
                    )
                })}
              </Box>
            </Toolbar>
          </Box>
        </AppBar>
      </HideOnScroll>
      
    </>
  );
}
export default NavBar;